import React, {Fragment, PureComponent} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import queryString from 'query-string';

import {
  Wrapper,
  Title,
  Head,
  LinkButton,
  ButtonWrapper,
} from '../../styles/pages/pages';
import {
  SectionTitle,
  SectionText,
  SectionWrapper,
  TheLink,
  Tel,
  SubmitTakingTooLong,
  Error,
} from './ConfirmationPage.style';
import {removeBasket, setCurrentRoute} from '../../actions';
import {authAdyenPayment, resetCheckout} from '../../actions/checkout.action';
import MarketingOptions from '../../components/Marketing/MarketingOptions';
import PromoBanner from '../../components/PromoBanner/PromoBanner';
import {resetNextRoute} from '../../actions/nextRoute.action';
import {removeSetting} from '../../actions/settings.action';
import {
  ANALYTICS_EVENTS,
  AX_ORDER_STATUS,
  JJ_TEL,
  JJ_TEL_FULL,
  PAYMENT_TYPES,
  SERVICE_TYPE,
  ROUTES,
  CHECKOUT_TAKING_LONGER_TIMEOUT,
  CHECKOUT_TAKING_LONGEST_TIMEOUT,
  ADYEN_DONATION_CAMPAIGN,
  JJ_LOCAL_STORAGE,
  CONFIRMATION_PRICE_COMPARE_BANNER,
  PBB_PENDING_POLL_SCHEDULE,
  PBB_PENDING_SLOW_TIMEOUT,
  CHECKOUT_RESULT,
} from '../../constants/constants';
import {getOrderAfterCheckout, resetOrder} from '../../actions/order.action';
import {GoogleAnalyticsHelper} from '../../helpers/googleAnalytics.helper';
import Loading from '../../components/Loading/Loading';
import {
  extractCollectionTime,
  extractDeliveryTime,
} from '../../helpers/array.helper';
import PopupModal from '../../components/PopupModal/PopupModal';
import {AdyenCheckout, Donation} from '@adyen/adyen-web';
import {AdyenContent, AydenWrapper} from '../CheckoutPage/CheckoutPage.style';
import {captureException} from '@sentry/browser';
import {checkIsDev} from '../../helpers/data.helper';
import {
  pbbPendingPollDelay,
  pbbPendingSlowDelay,
} from '../../helpers/payByBank.helper';
import {getOrderIdFromConfirmationPath} from '../../helpers/string.helper';
import {isPayByBankAwaitingBank} from '../../helpers/order.helper';
import {AdyenStyle} from '../../styles/adyen.style';
import {removeValueFromLocalStorage} from '../../helpers/localStorage.helper';

class ConfirmationPage extends PureComponent {
  requestOrder = true;
  receivedOrder = false;
  // The last status reported to analytics. Per status rather than once: with
  // the pending order re-read in place, PENDING -> EXPIRED/CANCELLED is now
  // seen on this page and must be tracked too.
  trackedStatus = null;
  paymentRequiresMultiAuthSet = false;

  constructor(props) {
    super(props);
    this.state = {
      isSubmitTakingLonger: false,
      showPaymentRequiresMultiAuth: false,
      showDonationDropin: true,
      showDonationThankYou: false,
      isPendingSlow: false,
    };
    this.donationDropin = null;
  }

  componentDidMount() {
    const {
      location,
      setCurrentRoute,
      resetNextRoute,
      history,
      basket,
      checkout,
      resetCheckout,
    } = this.props;
    resetNextRoute();
    setCurrentRoute(ROUTES.CONFIRMATION);
    if (location && location.state) {
      if (location.state.basketId) {
        this.basketId = location.state.basketId;
      }
      if (location.state.axBasketId) {
        this.basketId = location.state.axBasketId;
      }
      if (location.state.orderId) {
        this.orderId = location.state.orderId;
      }
      if (location.state.fromOrders) {
        this.fromOrders = true;
      }
    }
    const params = queryString.parse(location.search);
    if (!!params.callback) {
      history.replace({search: ''});
    }
    if (!this.orderId) {
      // No id in the route state (a bank redirect back, or a checkout that
      // reused a pending order): take it from the path.
      this.orderId = getOrderIdFromConfirmationPath(location.pathname);
    }

    // The order is not loaded yet at this point, so whether this is a Pay By
    // Bank checkout has to come from what the checkout left behind: the
    // basket's payment method, or the checkout result when the basket has
    // already gone.
    const isPayByBank =
      (basket && basket.paymentMethod === PAYMENT_TYPES.PBB.mode) ||
      (checkout &&
        (checkout.result === CHECKOUT_RESULT.PAYMENT_ECOSPEND ||
          checkout.result === CHECKOUT_RESULT.PAYMENT_IN_PROGRESS));
    const timeoutTimes = isPayByBank
      ? CHECKOUT_TAKING_LONGEST_TIMEOUT
      : CHECKOUT_TAKING_LONGER_TIMEOUT;
    if (checkout && checkout.result === CHECKOUT_RESULT.PAYMENT_IN_PROGRESS) {
      // Read above; nothing else needs it. Left in state it would bounce the
      // customer off Checkout on every basket sync (App's handler treats any
      // checkout as in flight) and seed the next checkout's total from this
      // order.
      resetCheckout();
    }

    this.submitTakingLongerTimer = setTimeout(() => {
      this.submitTakingLongerTimer = null;
      this.setState({isSubmitTakingLonger: true});
    }, timeoutTimes);
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    this.watchPendingPayment();
    const {
      adyen,
      auth,
      checkout,
      removeBasket,
      resetCheckout,
      history,
      resetNextRoute,
      order,
      basket,
      getOrderAfterCheckout,
      basketHashMap,
      errors,
    } = this.props;
    if (auth && this.requestOrder) {
      this.requestOrder = false;
      getOrderAfterCheckout(this.orderId);
    }
    if (!!auth && order && order !== prevProps.order) {
      resetNextRoute();
    }
    if (
      auth &&
      order &&
      basket &&
      basketHashMap &&
      order.status &&
      order.status !== AX_ORDER_STATUS.PAYMENT_VOIDED &&
      // PAYMENT_AUTH_REQUIRED is not excluded: it is a placed order (its
      // payment was reversed and is confirmed again from My Orders), so its
      // basket is used up and must go like any placed order's. The page shows
      // the payment-required copy, not the success copy.
      order.status !== AX_ORDER_STATUS.CANCELLED &&
      order.status !== AX_ORDER_STATUS.SLOT_EXPIRED &&
      order.status !== AX_ORDER_STATUS.EDIT_EXPIRED &&
      order.status !== AX_ORDER_STATUS.TOTAL_DISCREPANCY &&
      // Held or released Pay By Bank orders have not been placed: the basket
      // must stay. While held, the bank may still send the payment, so the
      // customer waits here; once released, they check out again from it.
      order.status !== AX_ORDER_STATUS.PAYMENT_PENDING &&
      order.status !== AX_ORDER_STATUS.PAYMENT_PENDING_EXPIRED
    ) {
      // wait until setting & basket & basketHashMap populated to avoid timing issues
      if (order.items && !this.receivedOrder) {
        this.receivedOrder = true;
        history.replace(location.pathname, {});
      }
      let donationCampaign;
      let donationCampaignName;
      try {
        donationCampaign = JSON.parse(checkout.adyenGiving);
        donationCampaignName = donationCampaign.donationCampaigns[0].causeName;
      } catch (e) {
        console.info('No donation campaign found for checkout.', checkout);
      }

      if (
        order.status !== AX_ORDER_STATUS.PAYMENT_AUTH_REQUIRED &&
        checkout &&
        checkout.adyenGiving &&
        donationCampaign.donationCampaigns.length > 0 &&
        donationCampaignName
      ) {
        this.openAdyenGiving();
        this.setState({donationCampaignName});
      }
      removeBasket();
      resetNextRoute();
      resetCheckout();
      removeValueFromLocalStorage(JJ_LOCAL_STORAGE.ORDER_ID);
      removeValueFromLocalStorage(JJ_LOCAL_STORAGE.ORDER_AX_BASKETID);
    }
    if (
      auth &&
      order &&
      basket &&
      basketHashMap &&
      (order.status === AX_ORDER_STATUS.PAYMENT_VOIDED ||
        order.status === AX_ORDER_STATUS.CANCELLED)
    ) {
      if (!this.receivedOrder) {
        this.receivedOrder = true;
        history.replace(location.pathname, {});
      }
    }
    this.trackStatusChange();
    if (
      auth &&
      order &&
      (order.status === AX_ORDER_STATUS.PAYMENT_PENDING ||
        order.status === AX_ORDER_STATUS.PAYMENT_PENDING_EXPIRED)
    ) {
      if (!this.receivedOrder) {
        this.receivedOrder = true;
        history.replace(location.pathname, {});
      }
    }
    if (
      order &&
      order.paymentRequiresMultiAuth &&
      !this.paymentRequiresMultiAuthSet
    ) {
      this.paymentRequiresMultiAuthSet = true;
      this.setState({showPaymentRequiresMultiAuth: true});
    }
    if (
      adyen &&
      adyen.donationStatus === 'success' &&
      window.isSubmittingAdyen
    ) {
      window.isSubmittingAdyen = false;
      this.donationDropin.setStatus('success');
      this.openDonationThankYou();
      this.setState({
        showDonationDropin: false,
      });
    }
    if (
      adyen &&
      adyen.donationStatus === 'failed' &&
      window.isSubmittingAdyen
    ) {
      window.isSubmittingAdyen = false;
      this.donationDropin.setStatus('error');
    }
    if (errors && errors.adyen) {
      this.donationDropin && this.donationDropin.update();
      window.isSubmittingAdyen = false;
    }
  }

  componentWillUnmount() {
    clearTimeout(this.submitTakingLongerTimer);
    this.submitTakingLongerTimer = null;
    this.stopWatchingPendingPayment();
    this.props.resetOrder();
  }

  // Analytics for the statuses this page explains rather than confirms, once
  // per status it moves into. A successful checkout's CONFIRM_ORDER is fired
  // by the analytics reducer, including after a pending payment resolves.
  trackStatusChange = () => {
    const {auth, order} = this.props;
    if (
      !auth ||
      !order ||
      !order.status ||
      order.status === this.trackedStatus
    ) {
      return;
    }
    const previous = this.trackedStatus;
    this.trackedStatus = order.status;
    const details = {
      orderId: order.orderId,
      axBasketId: order.axBasketId,
      paymentMethod: order.paymentMethod,
      total: order.price && order.price.total,
    };
    if (previous === AX_ORDER_STATUS.PAYMENT_PENDING) {
      GoogleAnalyticsHelper.trackEvent(
        ANALYTICS_EVENTS.PBB_PAYMENT_PENDING_RESOLVED,
        {...details, status: order.status}
      );
    }
    switch (order.status) {
      case AX_ORDER_STATUS.PAYMENT_PENDING:
        GoogleAnalyticsHelper.trackEvent(
          ANALYTICS_EVENTS.PBB_PAYMENT_PENDING,
          details
        );
        break;
      case AX_ORDER_STATUS.PAYMENT_PENDING_EXPIRED:
        GoogleAnalyticsHelper.trackEvent(
          ANALYTICS_EVENTS.PBB_PAYMENT_PENDING_EXPIRED,
          details
        );
        break;
      case AX_ORDER_STATUS.PAYMENT_VOIDED:
      case AX_ORDER_STATUS.CANCELLED:
        GoogleAnalyticsHelper.trackEvent(ANALYTICS_EVENTS.PAYMENT_FAILED, {
          order,
        });
        break;
      default:
        break;
    }
  };

  // While a Pay By Bank payment is pending, keep re-reading the order: the
  // money usually lands moments later, and moving on to the confirmation must
  // not depend on the websocket being connected. The reads slow down the
  // longer it has been pending (PBB_PENDING_POLL_SCHEDULE) and pause while the
  // tab is hidden. Also switch the copy from "confirming" to "waiting for your
  // bank" if it is still pending after a while, counted from when it went
  // pending.
  watchPendingPayment = () => {
    const {order} = this.props;
    const isAwaitingBank = isPayByBankAwaitingBank(order);
    const isPending =
      isAwaitingBank ||
      (!!order && order.status === AX_ORDER_STATUS.PAYMENT_PENDING);
    if (isAwaitingBank && !this.awaitingBankSince) {
      // No status to count from yet, so the poll schedule and the slow copy
      // count from when the page started waiting.
      this.awaitingBankSince = new Date().toISOString();
      GoogleAnalyticsHelper.trackEvent(ANALYTICS_EVENTS.PBB_AWAITING_BANK, {
        orderId: order.orderId,
        axBasketId: order.axBasketId,
        total: order.price && order.price.total,
      });
    }
    if (!isPending) {
      if (this.watchingPending) {
        this.stopWatchingPendingPayment();
        this.setState({isPendingSlow: false});
      }
      return;
    }
    if (this.watchingPending) {
      return;
    }
    this.watchingPending = true;
    document.addEventListener('visibilitychange', this.onVisibilityChange);
    this.schedulePendingRefresh();
    const slowDelay = pbbPendingSlowDelay(
      order.statusChangedAt || this.awaitingBankSince,
      Date.now(),
      PBB_PENDING_SLOW_TIMEOUT
    );
    if (slowDelay === 0) {
      // Already pending for a while (a reopened order): no spinner first.
      this.markPendingSlow();
    } else {
      this.pendingSlowTimer = setTimeout(this.markPendingSlow, slowDelay);
    }
  };

  markPendingSlow = () => {
    const {order} = this.props;
    this.pendingSlowTimer = null;
    this.setState({isPendingSlow: true});
    GoogleAnalyticsHelper.trackEvent(
      ANALYTICS_EVENTS.PBB_PAYMENT_PENDING_SLOW,
      {
        orderId: order && order.orderId,
        axBasketId: order && order.axBasketId,
      }
    );
  };

  schedulePendingRefresh = () => {
    const {order} = this.props;
    clearTimeout(this.pendingRefresh);
    this.pendingRefresh = setTimeout(
      this.refreshPendingOrder,
      pbbPendingPollDelay(
        (order && order.statusChangedAt) || this.awaitingBankSince,
        Date.now(),
        PBB_PENDING_POLL_SCHEDULE
      )
    );
  };

  refreshPendingOrder = () => {
    this.pendingRefresh = null;
    if (!this.watchingPending || document.hidden) {
      // Picked up again by onVisibilityChange when the tab is shown.
      return;
    }
    this.props.getOrderAfterCheckout(this.orderId);
    this.schedulePendingRefresh();
  };

  onVisibilityChange = () => {
    if (this.watchingPending && !document.hidden && !this.pendingRefresh) {
      this.refreshPendingOrder();
    }
  };

  stopWatchingPendingPayment = () => {
    clearTimeout(this.pendingRefresh);
    clearTimeout(this.pendingSlowTimer);
    if (this.watchingPending) {
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
    }
    this.watchingPending = false;
    this.pendingRefresh = null;
    this.pendingSlowTimer = null;
  };

  resetPaymentRequiresMultiAuth = () => {
    this.setState({showPaymentRequiresMultiAuth: false});
  };

  openDonationThankYou = () => this.setState({showDonationThankYou: true});
  closeDonationThankYou = () => this.setState({showDonationThankYou: false});

  openAdyenGiving = async callback => {
    const {checkout, authAdyenPayment} = this.props;
    let paymentMethodsResponse = {paymentMethods: []};
    try {
      paymentMethodsResponse = JSON.parse(checkout.paymentMethods);
    } catch (e) {
      return captureException(e);
    }

    const configuration = {
      countryCode: 'GBR',
      paymentMethodsResponse,
      clientKey: checkout.clientKey,
      locale: 'en-US',
      environment: checkIsDev(checkout.clientKey),
      analytics: {
        enabled: true,
      },
    };
    const checkoutAdyen = await AdyenCheckout(configuration);
    const donationCampaign = JSON.parse(checkout.adyenGiving)
      .donationCampaigns[0];

    const donationConfig = {
      ...donationCampaign,
      onDonate: action => {
        if (action.isValid) {
          try {
            if (window.isSubmittingAdyen) {
              return;
            }
            window.isSubmittingAdyen = true;
            authAdyenPayment(
              checkout.responseUrl,
              {
                type: 'ADYEN',
                callState: 'donate',
                givingDonationRequest: {
                  campaignId: ADYEN_DONATION_CAMPAIGN,
                  amount: action.data.amount.value / 100,
                },
              },
              checkout.orderId
            );
            this.donationDropin.setStatus('loading');
          } catch (error) {
            captureException(error);
          }
        }
      },
      showCancelButton: false,
    };

    this.donationDropin = new Donation(checkoutAdyen, donationConfig).mount(
      '#adyen-donation-container'
    );
    setTimeout(() => {
      this.setState({
        showDonationDropin: false,
      });
    }, 40 * 60 * 1000);
  };

  render() {
    const {auth, order, errors, branchList, loading} = this.props;
    const {
      isSubmitTakingLonger,
      showPaymentRequiresMultiAuth,
      showDonationDropin,
      showDonationThankYou,
      donationCampaignName,
      isPendingSlow,
    } = this.state;
    // Back from the bank with no status yet is a payment in flight, shown as
    // pending: never as "taking longer than usual", never as a failure.
    const isAwaitingBank = isPayByBankAwaitingBank(order);
    const checkingOrderStatus =
      !order || (order && !order.status && !isAwaitingBank);
    const getOrderError = errors && errors.order;

    const submitTakingLongerText =
      !getOrderError &&
      checkingOrderStatus &&
      isSubmitTakingLonger &&
      'Submitting your order is taking longer than usual.';

    const renderGetOrderFailed = getOrderError && order && !order.status && (
      <SectionText>
        <p>
          Please try to checkout again. You will not be required to pay twice.
        </p>
        <p>
          If the problem persists please call{' '}
          <Tel href={`tel:${JJ_TEL_FULL}`}>Customer Support</Tel>.
        </p>
      </SectionText>
    );
    const renderLoading = checkingOrderStatus && !getOrderError && (
      <Loading isLight={false} />
    );
    const isPaymentPendingStatus =
      isAwaitingBank ||
      (order && order.status === AX_ORDER_STATUS.PAYMENT_PENDING);
    const isPaymentPendingExpiredStatus =
      order && order.status === AX_ORDER_STATUS.PAYMENT_PENDING_EXPIRED;
    const isPaymentAuthRequiredStatus =
      order && order.status === AX_ORDER_STATUS.PAYMENT_AUTH_REQUIRED;
    const isSuccessStatus =
      order &&
      !checkingOrderStatus &&
      !getOrderError &&
      order.status !== AX_ORDER_STATUS.PAYMENT_VOIDED &&
      order.status !== AX_ORDER_STATUS.CANCELLED &&
      !isPaymentPendingStatus &&
      !isPaymentPendingExpiredStatus &&
      !isPaymentAuthRequiredStatus;
    const renderWaitingTitle =
      checkingOrderStatus && !getOrderError && 'Please wait ';
    const renderSuccessTitle =
      isSuccessStatus &&
      (order && order.paymentRequiresMultiAuth ? 'Almost Done' : 'All done');
    const renderSuccessSectionTitle =
      !getOrderError &&
      isSuccessStatus &&
      'Thank you for ordering with JJ Foodservice';
    const renderSuccessPaymentText =
      !getOrderError &&
      isSuccessStatus &&
      this.fromOrders &&
      'Payment completed. ';
    const renderCollectionInfo =
      order &&
      order.fulfillmentType === SERVICE_TYPE.COLLECTION &&
      branchList &&
      branchList[order.branchId] &&
      branchList[order.branchId].name &&
      `from ${branchList[order.branchId].name} at ${extractCollectionTime(
        order.fulfillSlot
      )}`;
    const renderDeliveryInfo =
      order &&
      order.fulfillmentType === SERVICE_TYPE.DELIVERY &&
      extractDeliveryTime(order.fulfillSlot);
    const renderCollectionMessage = order &&
      order.fulfillmentType === SERVICE_TYPE.COLLECTION &&
      (order.paymentMethod === PAYMENT_TYPES.CDC.mode ||
        order.paymentMethod === PAYMENT_TYPES.BCDC.mode) && (
        <SectionText>
          Please bring your card with you when you collect your goods.
        </SectionText>
      );
    const renderSuccessMessage = isSuccessStatus && !getOrderError && (
      <Fragment>
        <SectionText>
          Your order {order.axBasketId} has now been placed.
          {renderCollectionMessage}
        </SectionText>
        <SectionText>Total items: {order.items.length}</SectionText>
        <SectionText>
          Total cost: £{order.price && order.price.total}
        </SectionText>
        <SectionText $extraMargin={true}>
          for {order.fulfillmentType} {renderCollectionInfo}
          {renderDeliveryInfo}
        </SectionText>
        <SectionText>
          You may edit this order up until the cutoff time. Please visit{' '}
          <TheLink to="/orders">My Orders</TheLink> to view and edit orders.
          <PromoBanner
            link={CONFIRMATION_PRICE_COMPARE_BANNER.LINK}
            desktopImage={CONFIRMATION_PRICE_COMPARE_BANNER.DESKTOP_IMAGE}
            mobileImage={CONFIRMATION_PRICE_COMPARE_BANNER.MOBILE_IMAGE}
            alt="JJ Price Compare AI"
          />
        </SectionText>
      </Fragment>
    );
    const isPaymentVoidStatus =
      order &&
      (order.status === AX_ORDER_STATUS.PAYMENT_VOIDED ||
        order.status === AX_ORDER_STATUS.CANCELLED);
    // A cancelled Pay By Bank order. Usually the customer (or their bank) did
    // not complete the payment and the provider cancelled it before anything
    // was placed, which is not a problem on our side, so it gets its own copy
    // rather than the generic "problem submitting your order". CANCELLED is
    // also where a placed order ends up if it is cancelled later, and the
    // order DTO does not say which of the two this is, so the copy must not
    // claim that no money was taken.
    const isPaymentCancelledPbb =
      order &&
      order.status === AX_ORDER_STATUS.CANCELLED &&
      order.paymentMethod === PAYMENT_TYPES.PBB.mode;
    const isPaymentVoidOther = isPaymentVoidStatus && !isPaymentCancelledPbb;
    // A failed read is not reported over an order already shown as pending.
    const isGetOrderErrorShown =
      !!errors && !!errors.order && !isPaymentPendingStatus;
    const renderPaymentVoidTitle =
      (isPaymentVoidOther || isGetOrderErrorShown) && 'Sorry';
    const renderPaymentVoidSectionTitle =
      (isPaymentVoidOther ||
        (getOrderError && order && !order.status) ||
        (!order && loading && !loading.order)) &&
      'Sorry there has been a problem submitting your order.';
    const renderPaymentCancelledTitle =
      isPaymentCancelledPbb && 'Payment not completed';
    const renderPaymentCancelledSectionTitle =
      isPaymentCancelledPbb && 'Your bank payment was not completed';
    const renderPBBPaymentMessage = order &&
      order.paymentMethod === PAYMENT_TYPES.PBB.mode && (
        <Fragment>
          <SectionText>
            Please, do not copy the details from the payment request to do a
            manual bank payment into the JJ Foodservice bank account.
          </SectionText>
          <SectionText>
            If you do this, it will not be registered correctly as a paid order
            on the system, and you won't get your order.
          </SectionText>
        </Fragment>
      );
    // Pay By Bank: the bank has accepted the payment but not sent the money
    // yet. The order is held, not placed. For almost every payment this is
    // brief (Trustly send pending and credit together), so it starts as a
    // neutral "confirming" state and only explains a bank-side approval wait
    // (typically a corporate account waiting on a second signatory) once it
    // has run long. There is deliberately no way to pay again from here: the
    // bank may still send this payment, and a second one could debit the
    // customer twice. If the hold lapses, the expired state below offers the
    // basket.
    const renderPaymentPendingTitle = isPaymentPendingStatus && 'Almost Done';
    const renderPaymentPendingSectionTitle =
      isPaymentPendingStatus &&
      (isPendingSlow
        ? 'We are waiting for your bank'
        : 'Confirming your payment');
    const onPayAnotherWay = () =>
      GoogleAnalyticsHelper.trackEvent(ANALYTICS_EVENTS.PBB_PAY_ANOTHER_WAY, {
        orderId: order && order.orderId,
        axBasketId: order && order.axBasketId,
        status: order && order.status,
      });
    const pendingAmount = order && order.price && order.price.total;
    const renderPaymentPendingMessage = isPaymentPendingStatus &&
      !isPendingSlow && (
        <Fragment>
          <Loading isLight={false} />
          <SectionText>
            {isAwaitingBank
              ? `We're waiting to hear from your bank about your payment of £${pendingAmount}, and this page will update as soon as we do.`
              : `Your bank has accepted your payment of £${pendingAmount}. We're waiting for it to reach us, and this page will update as soon as it does.`}
          </SectionText>
          <SectionText>Please don't pay again.</SectionText>
        </Fragment>
      );
    // No word from the bank at all for a while. Nothing is known to have gone
    // wrong, so the customer is asked to wait rather than to pay again, which
    // could take the money twice.
    const renderAwaitingBankSlowMessage = isAwaitingBank && isPendingSlow && (
      <Fragment>
        <SectionText>
          We still haven't heard from your bank about your payment of £
          {order.price && order.price.total}. This page will keep checking and
          will update as soon as we do.
        </SectionText>
        <SectionText>
          Please do not pay again: if your bank has sent this payment, a second
          one could take the money twice. You can also check{' '}
          <TheLink to="/orders">My Orders</TheLink> later, or call Customer
          Services on <Tel href={`tel:${JJ_TEL_FULL}`}>{JJ_TEL}</Tel>.
        </SectionText>
        {renderPBBPaymentMessage}
      </Fragment>
    );
    const renderPaymentPendingSlowMessage = isPaymentPendingStatus &&
      !isAwaitingBank &&
      isPendingSlow && (
        <Fragment>
          <SectionText>
            Your bank has accepted your payment of £
            {order.price && order.price.total} but has not sent it to us yet.
            This usually means someone else at your business needs to approve it
            in your online banking.
          </SectionText>
          <SectionText>
            We will place your order as soon as the money arrives and email you
            to confirm. If it does not arrive before your delivery cut-off, we
            will let you know and your basket will still be here.
          </SectionText>
          <SectionText>
            Please do not pay again, as your bank may still send this payment.
          </SectionText>
          {renderPBBPaymentMessage}
        </Fragment>
      );
    // A placed order whose payment was reversed or failed. It is listed on the
    // orders page, which is where the payment is confirmed again.
    const renderPaymentAuthRequiredTitle =
      isPaymentAuthRequiredStatus && 'Payment required';
    const renderPaymentAuthRequiredSectionTitle =
      isPaymentAuthRequiredStatus && 'Your payment was not completed';
    const onConfirmPaymentRequired = () =>
      GoogleAnalyticsHelper.trackEvent(
        ANALYTICS_EVENTS.PAYMENT_REQUIRED_CONFIRM,
        {
          orderId: order && order.orderId,
          axBasketId: order && order.axBasketId,
        }
      );
    const renderPaymentAuthRequiredMessage = isPaymentAuthRequiredStatus && (
      <Fragment>
        <SectionText>
          The payment for order {order.axBasketId} was not completed. Please
          confirm your payment from the orders page to prevent the order from
          being cancelled.
        </SectionText>
        <SectionText>
          If you need help please contact Customer Services on{' '}
          <Tel href={`tel:${JJ_TEL_FULL}`}>{JJ_TEL}</Tel>
        </SectionText>
        {renderPBBPaymentMessage}
        <SectionText>
          <ButtonWrapper>
            <LinkButton to="/orders" onClick={onConfirmPaymentRequired}>
              Confirm payment
            </LinkButton>
          </ButtonWrapper>
        </SectionText>
      </Fragment>
    );
    // The bank never sent the money and the hold has lapsed. Nothing was
    // placed and nothing was taken by us; the basket is untouched.
    const renderPaymentPendingExpiredTitle =
      isPaymentPendingExpiredStatus && 'Sorry';
    const renderPaymentPendingExpiredSectionTitle =
      isPaymentPendingExpiredStatus &&
      'Your bank did not complete this payment';
    const renderPaymentPendingExpiredMessage = isPaymentPendingExpiredStatus && (
      <Fragment>
        <SectionText>
          We waited for your bank to send your payment of £
          {order.price && order.price.total}, but it did not arrive in time, so
          the order has not been placed.
        </SectionText>
        <SectionText>
          Your basket is still here. Please{' '}
          <TheLink to="/basket">return to your basket</TheLink> and check out
          again, choosing another payment method if you prefer. If your bank
          does send the payment later, we will contact you to place the order or
          refund it.
        </SectionText>
        <SectionText>
          If you need help please contact Customer Services on{' '}
          <Tel href={`tel:${JJ_TEL_FULL}`}>{JJ_TEL}</Tel>
        </SectionText>
        {renderPBBPaymentMessage}
        <SectionText>
          <ButtonWrapper>
            <LinkButton to="/basket" onClick={onPayAnotherWay}>
              Return to basket
            </LinkButton>
          </ButtonWrapper>
        </SectionText>
      </Fragment>
    );
    const renderPaymentCancelledMessage = isPaymentCancelledPbb && (
      <Fragment>
        <SectionText>
          The payment was not completed and the order has not been placed.
        </SectionText>
        <SectionText>
          Your basket is still here. Please{' '}
          <TheLink to="/basket">return to your basket</TheLink> and check out
          again, choosing another payment method if you prefer.
        </SectionText>
        <SectionText>
          If money has left your account, or you need help, please contact
          Customer Services on <Tel href={`tel:${JJ_TEL_FULL}`}>{JJ_TEL}</Tel>
        </SectionText>
        {renderPBBPaymentMessage}
        <SectionText>
          <ButtonWrapper>
            <LinkButton to="/basket">Return to basket</LinkButton>
          </ButtonWrapper>
        </SectionText>
      </Fragment>
    );
    const renderPaymentVoidMessage = (isPaymentVoidOther ||
      isGetOrderErrorShown) && (
      <Fragment>
        <SectionText>
          Please <TheLink to="/basket">return to your basket </TheLink> and try
          to checkout again. You will not be required to pay twice.
        </SectionText>
        <SectionText>
          If the problem persists please contact Customer Services on{' '}
          <Tel href={`tel:${JJ_TEL_FULL}`}>{JJ_TEL}</Tel>
        </SectionText>
        {renderPBBPaymentMessage}
        <SectionText>
          <ButtonWrapper>
            <LinkButton to="/basket">Return to basket</LinkButton>
          </ButtonWrapper>
        </SectionText>
      </Fragment>
    );
    const renderPaymentRequiresMultiAuthModal = showPaymentRequiresMultiAuth && (
      <PopupModal
        modalName="Almost Done"
        content={
          <>
            Your payment needs authorised signatories’ approval before we can
            process it.
            <br />
            If your payment is not authorised, your order may be cancelled.
            <br />
            To avoid any delays or cancellations, please ask your bank account
            authoriser to log on to Business Internet Banking to authorise it.
          </>
        }
        title="Almost Done"
        callback={this.resetPaymentRequiresMultiAuth}
        showModal={showPaymentRequiresMultiAuth}
      />
    );
    const renderMarketingOptions = auth &&
      auth.email &&
      !getOrderError &&
      !isPaymentVoidStatus &&
      !isPaymentPendingStatus &&
      !isPaymentPendingExpiredStatus &&
      !isPaymentAuthRequiredStatus &&
      !checkingOrderStatus && (
        <MarketingOptions
          email={auth && auth.email}
          hideIfSubscribed={true}
          hideWhileLoading={true}
          simpleView={true}
        />
      );
    const renderAdyenGivingError = errors &&
      errors.adyen &&
      showDonationDropin && (
        <Error>
          {errors.adyen.message ||
            (errors.adyen.errors && errors.adyen.errors.GIVING)}
          , please try again.
        </Error>
      );
    const renderAdyenGiving = showDonationDropin && (
      <AydenWrapper>
        <AdyenContent id="adyen-donation-container" />
      </AydenWrapper>
    );
    const renderDonationThankYou = showDonationThankYou && (
      <PopupModal
        content={
          <>
            Your donation makes a real difference. We're incredibly grateful for
            your support in helping us with{' '}
            <strong>{donationCampaignName}</strong>
            <br />
            <br />
            Your contribution brings us closer to achieving our goals, and we
            couldn’t do it without amazing people like you. <br />
            <br />
            Thank you for being part of this journey. ❤️
          </>
        }
        title={'Thank you!'}
        isError={false}
        showModal={showDonationThankYou}
        showCancelButton={false}
        callback={this.closeDonationThankYou}
      />
    );
    return (
      <Wrapper>
        <AdyenStyle />
        <Head>
          <Title>
            {renderWaitingTitle}
            {renderSuccessTitle}
            {renderPaymentPendingTitle}
            {renderPaymentPendingExpiredTitle}
            {renderPaymentAuthRequiredTitle}
            {renderPaymentCancelledTitle}
            {renderPaymentVoidTitle}
          </Title>
        </Head>
        <SectionTitle>
          {renderSuccessPaymentText}
          {renderSuccessSectionTitle}
          {renderPaymentPendingSectionTitle}
          {renderPaymentPendingExpiredSectionTitle}
          {renderPaymentAuthRequiredSectionTitle}
          {renderPaymentCancelledSectionTitle}
          {renderPaymentVoidSectionTitle}
        </SectionTitle>
        <SectionWrapper>
          {renderLoading}
          <SubmitTakingTooLong>
            &nbsp;{submitTakingLongerText}&nbsp;
          </SubmitTakingTooLong>
          {renderSuccessMessage}
          {renderPaymentPendingMessage}
          {renderPaymentPendingSlowMessage}
          {renderAwaitingBankSlowMessage}
          {renderPaymentPendingExpiredMessage}
          {renderPaymentAuthRequiredMessage}
          {renderPaymentCancelledMessage}
          {renderPaymentVoidMessage}
          {renderGetOrderFailed}
          {renderAdyenGivingError}
          {renderAdyenGiving}
          {renderDonationThankYou}
        </SectionWrapper>
        <SectionWrapper>{renderMarketingOptions}</SectionWrapper>
        {renderPaymentRequiresMultiAuthModal}
      </Wrapper>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  adyen: state.adyen,
  order: state.order,
  basket: state.basket,
  basketHashMap: state.basketHashMap,
  checkout: state.checkout,
  errors: state.errors,
  branchList: state.branchList,
  loading: state.loading,
});

const mapDispatchToProps = dispatch => ({
  removeBasket: bindActionCreators(removeBasket, dispatch),
  removeSetting: bindActionCreators(removeSetting, dispatch),
  resetOrder: bindActionCreators(resetOrder, dispatch),
  resetCheckout: bindActionCreators(resetCheckout, dispatch),
  resetNextRoute: bindActionCreators(resetNextRoute, dispatch),
  setCurrentRoute: bindActionCreators(setCurrentRoute, dispatch),
  getOrderAfterCheckout: bindActionCreators(getOrderAfterCheckout, dispatch),
  authAdyenPayment: bindActionCreators(authAdyenPayment, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationPage);
